import React, { useState, useEffect } from "react";
import { XoxodayLongLogo } from "../../components/Icons";
import styled from "styled-components";
import { Typography } from "@plum-xoxo/admin-dsm";
import Email from "./components/Email";
import Password from "./components/Password";
import LastStep from "./components/LastStep";
import Processing from "./components/Processing";
import VerifyOtpScreen from "./components/VerifyOtpScreen";
import axios from "axios";
import { datas } from "./components/Counrty";
import config from "config";
import DomainExists from "./components/DomainExists";
import { NotificationContainer } from "react-notifications";
import profileService from "../../services/profileService";
import moment from "moment";

const StyledHeader = styled.div`
  padding-top: 28px;
  padding-left: 44px;
`;

const StyledBodyDiv = styled.div`
  background-color: ${(props) => props.theme.palette.light.c100};
`;

const StyledFooter = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  background-color: ${(props) => props.theme.palette.background.c01};
`;

const HeightedDiv = styled.div`
  max-width: 485px;
  margin: auto;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  padding: 40px;
  margin-top: 46px;
  background-color: ${(props) => props.theme.palette.common.white};
`;

const HeightedDivProgress = styled.div`
  width: 485px;
  margin: auto;
  border-radius: 8px;
  padding: 40px;
  margin-top: 46px;
`;

const BorderTopDiv = styled.div`
  padding: 28px 0;
  border-top: 1px solid ${(props) => props.theme.palette.light.c300};
`;

const SignUp = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [UID, setUID] = useState("");
  const [showCts, setShowCts] = useState(false);
  const [password, setPassword] = useState("");
  const [noOfEmployees, setNoOfEmployees] = useState("");
  const [region, setRegion] = useState("");
  const [countryData, setCountryData] = useState({});
  const [associationError, setAssociationError] = useState("");
  const [renderDomainScreen, setRenderDomain] = useState(false);
  const fetchCountryIP = async () => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let currency = response?.data?.currency || "INR";
        const currency_value = datas.filter((item) => item.code == currency);
        setCountryData(currency_value[0]);
      })
      .catch((error) => {
        console.log("Error in fetching country IP", error);
        let currency = "INR";
        const currency_value = datas.filter((item) => item.code == currency);
        setCountryData(currency_value[0]);
      });
  };
  const [countryISOCode, setCountryISOCode] = useState("");
  const url = config.storeFrontUrl.replace(/\/$/g, "");

  const redirectToSchedulePage = (countryISOCodeProps) => {
    if (window.innerWidth < 991) {
      const newCountryISOCode = countryISOCodeProps || countryISOCode || "";
      const countryRedirections = config?.adminMobileSignupRedirect || [];
      for (let i = 0; i < countryRedirections?.length; i++) {
        const redirection = countryRedirections[i];
        if (
          redirection?.countryISOCode === newCountryISOCode &&
          moment() < moment(redirection?.expiry)
        ) {
          window.location = redirection?.url;
          return;
        }
      }
      window.location = config?.adminMobileSignupRedirectDefaultURL;
    }
  };
  useEffect(() => {
    window.addEventListener("resize", redirectToSchedulePage);
    fetchCountryIP();
    profileService.fetchCountryBasedonIP().then((response) => {
      if (response?.plumApi?.output) {
        let ipBasedOutput = "";
        try {
          ipBasedOutput = JSON.parse(response?.plumApi?.output || "{}");
        } catch (e) {
          console.log("Parse Error in plumApi", e);
        }
        const countryCode = ipBasedOutput?.country_code;
        setCountryISOCode(countryCode);
        redirectToSchedulePage(countryCode);
      }
    });

    return () => {
      window.removeEventListener("resize", redirectToSchedulePage);
    };
  }, []);

  return (
    <StyledBodyDiv>
      <StyledHeader>
        <XoxodayLongLogo width={100} height={35} />
      </StyledHeader>
      {renderDomainScreen ? (
        <DomainExists />
      ) : (
        <>
          {currentStep === 4 ? (
            <HeightedDivProgress>
              <Processing UID={UID} email={email} countryData={countryData} />
            </HeightedDivProgress>
          ) : (
            <HeightedDiv className="d-flex">
              {currentStep === 0 && (
                <Email
                  setCurrentStep={setCurrentStep}
                  name={name}
                  email={email}
                  setEmail={setEmail}
                  setName={setName}
                  setUID={setUID}
                  showCts={showCts}
                  setShowCts={setShowCts}
                  associationError={associationError}
                  setAssociationError={setAssociationError}
                  setRenderDomain={setRenderDomain}
                  noOfEmployees={noOfEmployees}
                  setNoOfEmployees={setNoOfEmployees}
                  countryData={countryData}
                  region={region}
                  setRegion={setRegion}
                />
              )}
              {currentStep === 1 && (
                <VerifyOtpScreen
                  email={email}
                  UID={UID}
                  setCurrentStep={setCurrentStep}
                  showCts={showCts}
                />
              )}
              {currentStep === 2 && (
                <Password
                  email={email}
                  UID={UID}
                  password={password}
                  setPassword={setPassword}
                  setCurrentStep={setCurrentStep}
                />
              )}
              {currentStep === 3 && (
                <LastStep
                  email={email}
                  password={password}
                  setCurrentStep={setCurrentStep}
                  UID={UID}
                  noOfEmployees={noOfEmployees}
                  setNoOfEmployees={setNoOfEmployees}
                  region={region}
                  setRegion={setRegion}
                />
              )}
            </HeightedDiv>
          )}
        </>
      )}
      <StyledFooter className="w-100">
        <BorderTopDiv className="mx-44 d-flex justify-content-end align-items-center">
          <div className="d-flex gap-32">
            <a
              href="https://www.xoxoday.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography.LabelText
                color="dark"
                shade="c200"
                className="cursor-pointer"
              >
                Privacy
              </Typography.LabelText>
            </a>
            <a
              href="https://www.xoxoday.com/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography.LabelText
                color="dark"
                shade="c200"
                className="cursor-pointer"
              >
                Terms
              </Typography.LabelText>
            </a>
            <a
              href="https://www.giift.com/en/contact-us"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography.LabelText
                color="dark"
                shade="c200"
                className="cursor-pointer"
              >
                Get Help
              </Typography.LabelText>
            </a>
          </div>
        </BorderTopDiv>
      </StyledFooter>
      <NotificationContainer />
    </StyledBodyDiv>
  );
};

export default SignUp;
